import { Uppy } from '@uppy/core';
import XHRUpload from '@uppy/xhr-upload';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';

type Options = {
  onProgressChange: (progress: number) => void;
};
export const useUploadFileProgress = ({
  onProgressChange,
}: Options): ((uploadUrl: string, file: File) => Promise<File>) => {
  const { $t } = useIntl();

  return useCallback(
    async (uploadUrl: string, file: File) => {
      return new Promise((resolve, reject) => {
        try {
          const request = new Uppy({ debug: false, autoProceed: true });

          request.use(XHRUpload, {
            endpoint: uploadUrl,
            method: 'PUT',
            formData: false,
          });

          request.addFile({
            name: file.name,
            type: file.type,
            data: file,
          });

          request.on('error', (error) => {
            reject(error.message);
          });
          request.on('upload-progress', (file, progress) => {
            const newProgress =
              progress.bytesUploaded / (progress.bytesTotal ?? 1);
            onProgressChange(newProgress);
          });
          request.on('complete', () => {
            onProgressChange(1);
            resolve(file);
          });
        } catch {
          reject($t({ id: 'VIDEO_UPLOADING_ERROR' }));
        }
      });
    },
    [$t, onProgressChange]
  );
};
